import * as React from "react";
import moment from "moment";

import {dateFormat, externalValuationOptions} from "@/utils/constants";

import {getValuationScore} from "@/utils/functions";

import "./index.scss";

export default function ValuationCard(props) {
	const {element} = props;

	const external = element.valuationType > 1 || !element.valuationType;
	const player = element.player;
	const category = external
		? element.playerCategory?.name
		: player?.category !== "Non categorizzato"
			? player?.category
			: "";
	const birthDate = external ? player?.dateOfBirth : element?.dateOfBirth;

	const result = externalValuationOptions.filter(
		(v) =>
			v.value === (element.finalOverallRating ?? element.valuation)?.toString(),
	)?.[0]?.label;

	const imagePath = external
		? element.valuationType === 2 || element.valuationType === 4
			? require("@/assets/images/coach/match.png")
			: require("@/assets/images/coach/training.png")
		: require("@/assets/images/manager/evaluation.png");

	return (
		<div className="valuation-card-container">
			<div className="valuation-card-header">
				<div className="top-left">
					{moment(element.valuationDate).format(dateFormat)}
				</div>
				<div className="top-right">{category}</div>
			</div>
			<div className="valuation-card-info">
				<img src={imagePath} alt="" />
				<div className="info-container">
					<div className="info-title">
						{player?.firstName + " " + player?.lastName}
					</div>
					{birthDate ? (
						<div className="info-second-title">
							{moment(birthDate).format(dateFormat)}
						</div>
					) : null}
					<div className="info-second-title">
						{player?.goalkeeper ? "Portiere" : player?.primaryRole}
					</div>
				</div>
				<div className="info-subtitle">
					{getValuationScore(element) == null
						? "---"
						: +getValuationScore(element).toFixed(2)}
				</div>
			</div>
			<div className="separator"></div>
			<div className="valuation-card-preview">
				<div className="valuation-type">
					<div className="type-info">
						{element.valuationAuthor || element.signalerName || "---"}
					</div>
				</div>
				{external ? (
					<div className="valuation-stats">
						<div>{result || "---"}</div>
					</div>
				) : null}
			</div>
		</div>
	);
}
